module.exports = __webpack_public_path__ + "static/Affordability-d91af93b5836d61c95e0ba49dbc8a848.gif";